import PeluangApi from './PeluangApi'

export default PeluangApi